import { useState, useEffect, useCallback, useMemo } from 'react';
import { filterActivities, ACTIVITY_USAGE } from '../models/ActivitiesModel';
import { useNow } from '../views/components/shared/useNow';

/**
 * ViewModel for Activities: the token usage in the chosen scope, and the log
 * entries that pass the search and filters. Nothing in the log is editable.
 */
export const useActivitiesViewModel = (model) => {
  const [state, setState] = useState(() => model.getState());

  useEffect(() => {
    setState(model.getState());
    return model.subscribe(setState);
  }, [model]);

  // The range counts back from now, so it moves on the shared clock while the page sits open.
  const tick = useNow();
  const { entries, filters } = state;
  const visibleEntries = useMemo(
    () => filterActivities(entries, filters, model.now()),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- tick is the clock moving
    [entries, filters, model, tick],
  );

  const setFilter = useCallback((key, value) => model.setFilter(key, value), [model]);
  const clearSearchAndFilters = useCallback(() => model.clearSearchAndFilters(), [model]);
  const setSort = useCallback((sort) => model.setSort(sort), [model]);
  const setUsageScope = useCallback((scope) => model.setUsageScope(scope), [model]);

  return {
    ...state,
    usage: ACTIVITY_USAGE[state.usageScope],
    visibleEntries,
    setFilter,
    clearSearchAndFilters,
    setSort,
    setUsageScope,
  };
};
